// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x1tT","col":"styles_col__12XGK"};